'use strict';

var React = require('react');

var SvgDomainRedirectMinor = function SvgDomainRedirectMinor(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M10 3.778a6.222 6.222 0 1 0 3.726 11.205l-4.869-4.869v2.208a.889.889 0 0 1-1.778 0v-4.354a.89.89 0 0 1 .89-.889h4.353a.889.889 0 0 1 0 1.778h-2.208l4.87 4.87a6.193 6.193 0 0 0 1.237-3.727 6.222 6.222 0 0 0-6.221-6.222Zm-8 6.222a8 8 0 1 1 16 0 8 8 0 0 1-16 0Z"
  }));
};

exports.SvgDomainRedirectMinor = SvgDomainRedirectMinor;
